// extracted by mini-css-extract-plugin
export default {"root":"RemoveButton-root_toXkW"};